import NextLink from 'next/link'
import Head from 'next/head'
import React, { useEffect, useState } from 'react';
import { getPagination } from '../../utils/getPagination'
import Layout from '../../components/layout'
import DemoAccountInfo from '../../components/DemoAccountInfo'
import { 
  chakra, 
  Container as ChakraContainer, 
  Box, 
  Text, 
  LinkOverlay,
  Flex, Link, Heading, Stack, HStack, Center, Divider, Spinner, Spacer, SimpleGrid, 
  StatGroup, StatArrow, Stat, StatLabel, StatNumber, StatHelpText,
  useColorModeValue
} from '@chakra-ui/react'
import { TriangleDownIcon, TriangleUpIcon, ArrowForwardIcon } from '@chakra-ui/icons'
import { useTable, useSortBy } from 'react-table'
import Container from '../../components/Container';
import DataTable from '../../components/Table';
import useSWR, { SWRConfig } from "swr";
import { withServerSideAuth } from "@clerk/nextjs/ssr";
import prisma from '../../lib/prisma'

const fetcher = (url) =>
  fetch(url, {
    method: 'GET',
    headers: new Headers({ 'Content-Type': 'application/json'}),
    // credentials: 'same-origin',
  }).then((res) => res.json())

export default function Dashboard({userId}) {

  const borderColor = useColorModeValue("gray.200", "neutral.900")
  const subMenuLink = useColorModeValue("black", "white")
  const statBoxBG = useColorModeValue("gray.50", "neutral.1000")

  function useGenotype() {
    const { data, error, isValidating } = useSWR(`/api/user/getUserGenotype`,fetcher, {dedupingInterval: 15000, revalidateOnFocus: false })
    return {
      data: data,
      isLoading: !error && !data,
      isError: error
    }
  }

  function useGenotypeStats() {
    const { data, error, isValidating } = useSWR(`/api/user/getUserGenotypeStats`,fetcher, {dedupingInterval: 15000, revalidateOnFocus: false })
 
    return {
      data: data,
      isLoading: !error && !data,
      isError: error
    }
  }

  function usePhenotypeStats() {
    const { data, error, isValidating } = useSWR(`/api/user/getUserPhenotypeStats`,fetcher, {dedupingInterval: 15000, revalidateOnFocus: false })
 
    return {
      data: data,
      isLoading: !error && !data,
      isError: error
    }
  }

  function usePhenotype() {
    const { data, error, isValidating } = useSWR(`/api/user/getUserPhenotype`,fetcher, {dedupingInterval: 15000, revalidateOnFocus: false })
    
    return {
      data: data,
      isLoading: !error && !data,
      isError: error
    }
  }

  const { data: phenotypes, isLoading: phenotypesIsLoading, isError: phenotypesIsError } = usePhenotype()
  const { data: genotypes, isLoading: genotypesIsLoading, isError: genotypesIsError } = useGenotype()
  const { data: genotypeStats, isLoading: genotypeStatsIsLoading, isError: genotypeStatsIsError } = useGenotypeStats()
  const { data: phenotypeStats, isLoading: phenotypeStatsIsLoading, isError: phenotypeStatsIsError } = usePhenotypeStats()

// const phenotypesData = React.useMemo(
//   () => !phenotypesIsLoading ? phenotypes.results: null,
//   [],
// )

const userPhenotypesColumns = React.useMemo(
  () => [
    // {
    //   Header: 'Position',
    //   accessor: 'pos',
    //   // isNumeric: true,
    // },
    {
      Header: 'Name',
      accessor: 'phenotypes.name',
    },
    {
      Header: 'Status',
      accessor: 'significance',
    },
  ],
  [],
)


  // const GenotypesData = React.useMemo(
  //   () => genotypes.results,
  //   [],
  // )

  const userGenotypesColumns = React.useMemo(
    () => [
      // {
      //   Header: 'Position',
      //   accessor: 'pos',
      //   // isNumeric: true,
      // },
      {
        Header: 'ID',
        accessor: 'data_id',
      },
      {
        Header: 'Genotype',
        accessor: 'tgt',
      },
      {
        Header: 'Clinical Significance',
        accessor: 'clinvar.clinical_significance',
      },
    ],
    [],
  )

  useEffect(() => {
  }, [])

  return (
    <Layout>
        <Head>
          <title>Dashboard</title>
        </Head>
    <Container>
    <Divider variant="solid" orientation='horizontal'/>      
      <Box pb={50} px={4}>
      <Center>
      <HStack spacing={10} my={'45px'}>
      <NextLink href="/dashboard" passHref _hover={{textDecoration: 'none', color: 'black'}}>
      <Link href='#' fontSize="20" fontWeight="bold" _hover={{textDecoration: 'none', color: subMenuLink}}>Overview</Link>
        </NextLink>
        <NextLink href="/dashboard/variants" passHref>
          <Link color='gray.400' href='#' fontSize="20" fontWeight="bold" _hover={{textDecoration: 'none', color: subMenuLink}}>Variants</Link>
        </NextLink>
        <NextLink href="/dashboard/phenotypes" passHref _hover={{textDecoration: 'none', color: 'black'}}>
        <Link color='gray.400' href='#' fontSize="20" fontWeight="bold" _hover={{textDecoration: 'none', color: subMenuLink}}>Phenotypes</Link>
        </NextLink>
      </HStack>
      </Center>
        <SimpleGrid minChildWidth='130px' spacing='10px' mb={10}>
            <Box px={5} py={5} textAlign={'center'} bg={statBoxBG} borderRadius={10}>
                <Heading fontSize='14px' fontWeight={'600'} color={'gray.600'}>Total SNPs</Heading>
                {genotypeStatsIsLoading ? null : <Text fontSize='36px' fontWeight={'bold'}>{genotypeStats.count}</Text>}
            </Box>
            <Box px={5} py={5} textAlign={'center'} bg={statBoxBG} borderRadius={10}>
                <Heading fontSize='14px' fontWeight={'600'} color={'gray.600'}>Total Variants</Heading>
                {genotypeStatsIsLoading ? null : <Text fontSize='36px' fontWeight={'bold'}>{genotypeStats.variantCount}</Text>}
            </Box>
              <Box px={5} py={5} textAlign={'center'} bg={statBoxBG} borderRadius={10}>
                <Heading fontSize='14px' fontWeight={'600'} color={'gray.600'}>Pathogenic Variants</Heading>
                {genotypeStatsIsLoading ? null : <Text fontSize='36px' fontWeight={'bold'}>{genotypeStats.pathogenicCount}</Text>}
            </Box>
            <Box px={5} py={5} textAlign={'center'} bg={statBoxBG} borderRadius={10}>
                <Heading fontSize='14px' fontWeight={'600'} color={'gray.600'}>Benign Variants</Heading>
                {genotypeStatsIsLoading ? null : <Text fontSize='36px' fontWeight={'bold'}>{genotypeStats.benignCount}</Text>}
            </Box>
            <Box px={5} py={5} textAlign={'center'} bg={statBoxBG} borderRadius={10}>
                <Heading fontSize='14px' fontWeight={'600'} color={'gray.600'}>Carrier Conditions</Heading>
                {phenotypeStatsIsLoading ? null : <Text fontSize='36px' fontWeight={'bold'}>{phenotypeStats.carrier}</Text>}
            </Box>
            <Box px={5} py={5} textAlign={'center'} bg={statBoxBG} borderRadius={10}>
                <Heading fontSize='14px' fontWeight={'600'} color={'gray.600'}>Risk Conditions</Heading>
                {phenotypeStatsIsLoading ? null : <Text fontSize='36px' fontWeight={'bold'}>{phenotypeStats.risk}</Text>}
            </Box>
          </SimpleGrid>
      <SimpleGrid minChildWidth='400px' spacing='10px' mb={10}>
      <Box p={10} borderRadius={10} border={'1px'} borderColor={borderColor} overflow='scroll'>
        <Stack spacing={10}>
          <HStack spacing={6}>
            <Heading as="h2" size="lg">Variants</Heading>
            <NextLink href='/dashboard/variants' passHref><Link color={"cyan.500"} fontWeight={'normal'}>See all <ArrowForwardIcon mx='2px' /></Link></NextLink>
          </HStack>
          {genotypesIsLoading ? 
          <Center>
            <Spinner size={'lg'} thickness='3px' color={'cyan.400'}/>
          </Center>
          :
          <DataTable columns={userGenotypesColumns} data={genotypes.results} loading={genotypesIsLoading}/>
          }
        </Stack>
      </Box>
      <Box p={10} borderRadius={10} border={'1px'} borderColor={borderColor} overflow='scroll'>
        <Stack spacing={10}>
          <HStack spacing={6}>
            <Heading as="h2" size="lg">Phenotypes</Heading>
            <NextLink href='/dashboard/phenotypes' passHref><Link color={"cyan.500"} fontWeight={'normal'}>See all <ArrowForwardIcon mx='2px' /></Link></NextLink>
          </HStack>
          {phenotypesIsLoading ? 
          <Center>
            <Spinner size={'lg'} thickness='3px' color={'cyan.400'}/>
          </Center>  :
          <DataTable columns={userPhenotypesColumns} data={phenotypes.results} loading={phenotypesIsLoading}/>
          }
        </Stack>
      </Box>
      </SimpleGrid>
    </Box>
    </Container>
    </Layout>
  )
}

export const getServerSideProps = withServerSideAuth(async({ req, resolvedUrl }) => {
  const { userId, sessionId } = req.auth;
  // console.log(userId);

  if (!sessionId) {
    return { redirect: { destination: "/signin?redirect_url=" + resolvedUrl } };
  }

  // const user = await prisma.user.findMany({
  //   where: {
  //     clerk_id: userId
  //   },
  //   select: {
  //     id: true,
  //     email: true
  //   }
  // })
  // const user0 = user[0]

  var subQueryArgs = {user_id: userId}
  var reportQueryArgs = {user_id: userId}

  const [subscription, report] = await prisma.$transaction([
    prisma.subscriptions.findMany({
      where: subQueryArgs
    }),
    prisma.user_reports.findMany({
      where: reportQueryArgs
    })
  ])

  const sub_data = JSON.stringify(subscription, (key, value) => (typeof value === 'bigint' ? value.toString() : value))
  let results  = {sub: JSON.parse(sub_data), reports: report}

  if (results.sub.length == 0 || (results.sub.length > 0 && !results.sub[0].status == 'active')) {
    return {
      redirect: { destination: "/welcome" }
    }
  }

  if (results.reports.length > 0 && results.reports[0].report_ready == false && results.reports[0].report_init == true) {
    return {
      redirect: { destination: "/processing" }
    }
  }

  if (results.reports.length == 0) {
    return {
      redirect: { destination: "/upload-file" }
    }
  }
  
  if (results.reports.length > 0 && results.reports[0].report_init == false) {
    return {
      redirect: { destination: "/upload-file" }
    }
  }

  return { props: {userId: userId} };
});
